import React from "react";
import PropTypes from "prop-types";
import { QuestionFeedbackComponent } from "../QuestionFeedbackComponent";
import CorrectIcon from "@common/images/correct-relative.svg";
import IncorrectIcon from "@common/images/incorrect-relative.svg";
import style from "./style.module.scss";

const MESSAGE_TYPE = {
  SUCCESS: "SUCCESS",
  FAIL: "FAIL",
};

const MESSAGES = {
  [MESSAGE_TYPE.SUCCESS]: {
    message: null,
    icon: CorrectIcon,
    className: style.complete,
  },
  [MESSAGE_TYPE.FAIL]: {
    message: null,
    icon: IncorrectIcon,
    className: style.incomplete,
  },
};

/**
 *  QuestionFeedback:
 *  - Component checks answerIds and checkboxes in Quetion
 *     and determine the feedback to display.
 *  - The component gives a feeedback message for questions
 *  - A success message is displayed when all right answers are selected
 *  - A failure message is displayed when there are still correct answers to be selected.
 */

export function QuestionFeedback(props) {
  const { isPredictionQuestion = false } = props;
  let messageType = MESSAGE_TYPE.FAIL;

  if (props.showFeedback) {
    if (props.complete) messageType = MESSAGE_TYPE.SUCCESS;
    const feedbackProps = MESSAGES[messageType];
    if (props.feedback?.[`${messageType}_MESSAGE`]) {
      feedbackProps["message"] = props.feedback?.[`${messageType}_MESSAGE`];
    }
    feedbackProps.type = messageType;
    return <QuestionFeedbackComponent {...feedbackProps} />;
  }

  const allSubmittedOptions = props.checkboxes.reduce((list, checkbox) => {
    if (checkbox.disabled && checkbox.selected) list.push(checkbox.id);
    return list;
  }, []);
  let isAllAnswersSumitted = false;
  if (isPredictionQuestion) {
    isAllAnswersSumitted = props.answerId.some((answer) =>
      allSubmittedOptions.includes(answer)
    );
  } else {
    isAllAnswersSumitted = props.answerId.every((answer) =>
      allSubmittedOptions.includes(answer)
    );
  }
  if (allSubmittedOptions.length) {
    if (isAllAnswersSumitted) messageType = MESSAGE_TYPE.SUCCESS;
    const feedbackProps = MESSAGES[messageType];
    if (props.feedback?.[`${messageType}_MESSAGE`]) {
      feedbackProps["message"] = props.feedback?.[`${messageType}_MESSAGE`];
    }
    feedbackProps.type = messageType;
    return <QuestionFeedbackComponent {...feedbackProps} />;
  } else {
    return null;
  }
}

QuestionFeedback.propTypes = {
  /**
   * The className to be set for the componnet
   */
  className: PropTypes.string.isRequired,
  /**
   * The list of ID's for the correct Options
   */
  answerId: PropTypes.arrayOf(PropTypes.number).isRequired,
  /**
   * The list of options.
   */
  checkboxes: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * for keyboard navigation
   */
  tabIndex: PropTypes.string,
  /**
   * Custom feedback messages for SUCCESS and FAIL states
   */
  feedback: PropTypes.shape({
    SUCCESS_MESSAGE: PropTypes.string || PropTypes.object,
    FAIL_MESSAGE: PropTypes.string || PropTypes.object,
  }),
};

QuestionFeedback.defaultProps = {
  className: "",
  feedback: null,
};
